import { useUiTranslator } from "../../hooks/useUiTranslator";

import { JSX } from "react";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Button, Tooltip } from "@mui/material";

const CopyToClipboard = ({
  data,
}: {
  data: string | undefined;
}): JSX.Element => {
  const t = useUiTranslator();

  if (!data) {
    return <></>;
  }

  const handleCopy = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(data);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  return (
    <Tooltip title={t("CustomApp:tooltip.copyToClipboard", "Copy")}>
      <Button onClick={handleCopy} sx={{ minWidth: "30px" }}>
        <ContentCopyIcon
          sx={{
            height: "20px",
          }}
        />
      </Button>
    </Tooltip>
  );
};

export default CopyToClipboard;
